import PGPayments from './pg/payments';
import PGV2Payments from './pg/v2/Payments';
import PGV2Refunds from './pg/v2/refunds';
import PGOrders from './pg/orders';
import PGV2Orders from './pg/v2/orders';
import PGRefunds from './pg/refunds';
import PGSuspicious from './pg/suspicious';
import PGV2Suspicious from './pg/v2/suspicious';
import PGSettlements from './pg/settlements';
import PGV2Settlements from './pg/v2/settlements';
import PGV2Disputes from './pg/v2/disputes';
import PGV2PaymentForms from './pg/v2/paymentForms';
import ImportsPgPayments from './imports/payments';
import ImportsV2PgPayments from './imports/v2/payments';
import ImportsPgOrders from './imports/orders';
import ImportsV2PgOrders from './imports/v2/orders';
import ImportsPgRefunds from './imports/refunds';
import ImportsV2PgRefunds from './imports/v2/refunds';
import ImportsPgSuspicious from './imports/suspicious';
import ImportsV2PgSuspicious from './imports/v2/suspicious';
import ImportPgSettlements from './imports/settlements';
import ImportsV2PgSettlements from './imports/v2/settlements';
import ImportPgPaymentVerification from './imports/paymentVerification';
import ImportPgReports from './imports/reports';
import ImportsV2PgDisputes from './imports/v2/disputes';

export const getTableConfig = ({
  page,
  isImportEnabled,
  isV2Enabled = false,
}: {
  page: string;
  isImportEnabled: boolean;
  isV2Enabled?: boolean;
}) => {
  let configMapper;
  if (isImportEnabled) {
    configMapper = {
      PAYMENTS: isV2Enabled ? ImportsV2PgPayments : ImportsPgPayments,
      ORDERS: isV2Enabled ? ImportsV2PgOrders : ImportsPgOrders,
      REFUNDS: isV2Enabled ? ImportsV2PgRefunds : ImportsPgRefunds,
      SUSPICIOUS: isV2Enabled ? ImportsV2PgSuspicious : ImportsPgSuspicious,
      SETTLEMENTS: isV2Enabled ? ImportsV2PgSettlements : ImportPgSettlements,
      PAYMENT_VERIFICATION: ImportPgPaymentVerification,
      REPORTS: ImportPgReports,
      ...(isV2Enabled ? { DISPUTES: ImportsV2PgDisputes } : {}),
    };
  } else {
    configMapper = {
      PAYMENTS: isV2Enabled ? PGV2Payments : PGPayments,
      ORDERS: isV2Enabled ? PGV2Orders : PGOrders,
      REFUNDS: isV2Enabled ? PGV2Refunds : PGRefunds,
      SUSPICIOUS: isV2Enabled ? PGV2Suspicious : PGSuspicious,
      SETTLEMENTS: isV2Enabled ? PGV2Settlements : PGSettlements,
      ...(isV2Enabled ? { DISPUTES: PGV2Disputes } : {}),
      ...(isV2Enabled ? { PAYMENT_FORMS: PGV2PaymentForms } : {}),
    };
  }

  const config = configMapper[page];

  return config;
};
